import { useAppConfig } from '../config/runtime-config';

/**
 * Hook to get the server URL from runtime configuration
 * Falls back to current origin (window.location.origin) if runtime config fails
 */
export const useServerUrl = (): string => {
  try {
    const config = useAppConfig();
    return config.serverUrl;
  } catch {
    // Fallback to current origin (client is served by same server)
    return window.location.origin;
  }
};

export default useServerUrl;

